/**
 * The prescription type enum
 */
export enum PrescriptionType {
  SELECT_TEST = "select-test",
  DIRECT = "direct",
  REPROGRAMMING = "reprogramming",
}
